import { combineReducers } from 'redux';

import {
  REPORTS_INVOICES_SET_LIST_INVOICE,
  REPORTS_INVOICES_SET_OUTLETS,
  REPORTS_INVOICES_SET_HAS_MORE,
  REPORTS_INVOICES_SET_NEXT_CURSOR,
} from '../../actions/reports/invoicesv2/constants';
import createReducer from '../../utils/createReducer';

const invoices = createReducer(
  {
    results: [],
  },
  {
    [REPORTS_INVOICES_SET_LIST_INVOICE]: (draft, { payload }) =>
      // @ts-expect-error Object is possibly 'undefined'.ts(2532)
      payload.invoices,
  }
);

const outlets = createReducer([], {
  // @ts-expect-error Object is possibly 'undefined'.ts(2532)
  [REPORTS_INVOICES_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const nextCursor = createReducer('', {
  [REPORTS_INVOICES_SET_NEXT_CURSOR]: (draft, { payload }) =>
    // @ts-expect-error Object is possibly 'undefined'.ts(2532)
    payload.nextCursor,
});

const hasMore = createReducer(false, {
  // @ts-expect-error Object is possibly 'undefined'.ts(2532)
  [REPORTS_INVOICES_SET_HAS_MORE]: (draft, { payload }) => payload.hasMore,
});

export default combineReducers({
  invoices,
  outlets,
  hasMore,
  nextCursor,
});
